import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e0e3670"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gallery-swiper" }
const _hoisted_2 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_swiper, {
      "slides-per-view": _ctx.slidesPerView,
      "space-between": _ctx.spaceBetween,
      navigation: _ctx.product.imagesUrl.length > 2
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.imagesUrl, (image, index) => {
          return (_openBlock(), _createBlock(_component_swiper_slide, {
            key: index,
            virtualIndex: index,
            class: _normalizeClass({ 'last-slide': index === _ctx.product.imagesUrl.length - 1 })
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: image.url,
                class: "image-slide",
                onClick: _withModifiers(($event: any) => (_ctx.slideTo(index)), ["prevent"])
              }, null, 8, _hoisted_2)
            ]),
            _: 2
          }, 1032, ["virtualIndex", "class"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["slides-per-view", "space-between", "navigation"])
  ]))
}